export const CONTENTFUL_ABOUT_SECTION_ID = "2mapIJEy9rtnVCc7fOxHho";
export const CONTENTFUL_CONTACT_SECTION_ID = "4rSUtvndUctnjUsU6gYeGe";
export const CONTENTFUL_CAROUSEL_ID = "uKx57PgHDNeFSy2jrTqFI";
export const CONTENTFUL_HEADER_ID = "3IDNIjXNCkiCijnbEgz45g";
export const CONTENTFUL_MENU_SECTION_ID = "1rabdVcI4k4dPNtugRQhEw";
export const CONTENTFUL_SOCIAL_SECTION_ID = "01jsCCYtoQYgAlxWNDAQVn";
